"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import CircularProgress from "@mui/material/CircularProgress"
import Backdrop from "@mui/material/Backdrop"

type LoaderProps = {
  handleOnClick?: () => void
  size?: number
  variant?: "fullscreen" | "section"
  /** When true, Backdrop stacks above MUI Dialog (default z-index is only above drawer). */
  stackAboveModal?: boolean
}

const Loader = ({
  handleOnClick,
  size,
  variant = "fullscreen",
  stackAboveModal = false,
}: LoaderProps) => {
  if (variant === "section") {
    return (
      <div
        className="absolute inset-0 z-20 flex items-center justify-center bg-white/70"
        onClick={handleOnClick}
      >
        <CircularProgress size={size} />
      </div>
    )
  }

  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) =>
          stackAboveModal ? theme.zIndex.modal + 1 : theme.zIndex.drawer + 1,
      }}
      open={true}
      onClick={handleOnClick}
    >
      <CircularProgress size={size} />
    </Backdrop>
  )
}

export default Loader
